module.exports = __webpack_public_path__ + "static/team-2-c708c10d0931596c7aba707da61e460c.png";